/*
 * Copyright © 2016-2020 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import './system-settings.scss';

/* eslint-disable import/no-unresolved, import/default */

import systemSettingsTemplate from './system-settings.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

const SubscriptionStatusColorMap = {
    ['active']: '#306e24',
    ['future']: '#6200ea',
    ['cancelled']: '#b67b2e',
    ['non_renewing']: '#aa2c39'
};

export default angular.module('agrolog.client.systemSettings', [])
    .directive('agSystemSettings', SystemSettings)
    .name;

/*@ngInject*/
function SystemSettings() {
    return {
        restrict: "E",
        scope: true,
        bindToController: {
            ctx: '='
        },
        controller: SystemSettingsController,
        controllerAs: 'vm',
        templateUrl: systemSettingsTemplate
    };
}

/* eslint-disable angular/angularelement */

/*@ngInject*/
function SystemSettingsController($scope, $translate, $filter, $window, types, agTypes, userService, attributeService, siteService, agUtils, customerService) {

    let vm = this;

    vm.agTypes = agTypes;

    vm.loading = false;
    vm.countDown = 0;
    vm.customer;

    vm.showData = userService.getAuthority() === 'TENANT_ADMIN' || userService.getAuthority() === 'CUSTOMER_USER';
    vm.system = null;

    vm.selectedCrops = [];
    vm.calibrationList = [];
    vm.searchText = "";
    vm.allowEditSettings = true;
    vm.showSubscriptions = false;
    vm.manageSubscriptionData = {};
    vm.SubscriptionStatusColorMap = SubscriptionStatusColorMap;

    var user = userService.getCurrentUser();

    if (user.authority === 'CUSTOMER_USER') {
        var userAdditionalInfo = userService.getCurrentUserDetails().additionalInfo;
        if (userAdditionalInfo.readOnly) {
            vm.allowEditSettings = false;
        }
    }

    vm.helpPageAction = agUtils.createHelpActionConfig("agSystem", "ag.docsPageSections.system-settings");

    vm.searchCrops = searchCrops;
    vm.cropAdded = cropAdded;
    vm.cropRemoved = cropRemoved;
    vm.addCropsToCalibrationList = addCropsToCalibrationList;
    vm.openChargebeePortal = openChargebeePortal;
    vm.deleteCropFromCalibrationList = deleteCropFromCalibrationList;

    customerService.getCustomer(userService.getCurrentUser().customerId, {ignoreErrors: true}).then((customer) => {
        if (customer.endPaymentDate !== 0) {
            vm.countDown = formatTheDate(customer.endPaymentDate);
        }

        vm.customer = customer;

        let attributesPromise = attributeService.getEntityAttributesValues(customer.id.entityType, customer.id.id, types.attributesScope.server.value, ["viaReseller"]);
        attributesPromise.then(
            function success(data) {
                if (data.length) {
                    const attributeValue = angular.fromJson(data[0].value);
                    let viaReseller = attributeValue === true || attributeValue === 'true';

                    loadSubscriptions(viaReseller);
                } else {
                    loadSubscriptions(false);
                }
            },
            function fail() {
                loadSubscriptions(false);
            }
        );
    });

    $scope.$watch('vm.ctx', function() {
        if (vm.ctx) {
            vm.ctx.widgetActions = [vm.helpPageAction];
            vm.ctx.hideTitlePanel = false;
            vm.ctx.widgetTitle = $translate.instant('ag.system.system-settings') + '';
            loadSystem();
        }
    });

    $scope.$watch('vm.calibrationList', () => {
            if (vm.system) {
                var attributes = [];
                var attributeValue = {};
                if (vm.calibrationList.length) {
                    for (var i = 0; i < vm.calibrationList.length; i++) {
                        attributeValue[vm.calibrationList[i].nameId] = vm.calibrationList[i].calibrationValue;
                    }
                }
                attributes.push({key: 'moistureCalibrations', value: angular.toJson(attributeValue)});
                attributeService.saveEntityAttributes(vm.system.id.entityType, vm.system.id.id,
                    types.attributesScope.server.value, attributes)
                    .then(function success() {});
            }
        }, true
    );

    function loadSystem() {
        vm.loading = true;
        vm.system = null;
        siteService.getSystem().then(
            (system) => {
                vm.system = system;
                agUtils.getCropNames().then(
                    (cropResponse) => {
                        vm.unselectedCrops = [];
                        var cropNames = cropResponse.jsonValue;
                        for (var property in cropNames) {
                            var cropNameObj = {};
                            cropNameObj.nameId = property;
                            cropNameObj.value = cropNames[property];
                            cropNameObj.calibrationValue = 0;
                            vm.unselectedCrops.push(cropNameObj);
                        }
                        var calibrationObj = angular.fromJson(vm.system.moistureCalibrations);
                        if (calibrationObj) {
                            for (var prop in calibrationObj) {
                                for (var i = 0; i < vm.unselectedCrops.length; i++) {
                                    if (prop == vm.unselectedCrops[i].nameId) {
                                        vm.unselectedCrops[i].calibrationValue = calibrationObj[prop];
                                        vm.calibrationList.push(vm.unselectedCrops[i]);
                                        vm.unselectedCrops.splice(i, 1);
                                        break;
                                    }
                                }
                            }
                        }
                        vm.loading = false;
                    },
                    () => {
                        vm.loading = false;
                    }
                );
            },
            () => {
                vm.loading = false;
            }
        );

    }

    function loadSubscriptions(viaReseller) {
        vm.showSubscriptions = userService.getAuthority() === 'CUSTOMER_USER' && !viaReseller;
        if (vm.showSubscriptions) {
            userService.loadSubscriptions().then((manageSubscriptionData) => {
                vm.manageSubscriptionData = manageSubscriptionData ?? {};
            });
        }
    }

    function openChargebeePortal() {
        $window.open(vm.manageSubscriptionData.portalSessionUrl);
    }

    function addCropsToCalibrationList() {
        vm.calibrationList = vm.calibrationList.concat(vm.selectedCrops);
        vm.selectedCrops = [];
    }

    function deleteCropFromCalibrationList($event, crop) {
        if ($event) {
            $event.stopPropagation();
        }
        for (var i = 0; i < vm.calibrationList.length; i++) {
            if (crop.nameId == vm.calibrationList[i].nameId) {
                vm.calibrationList.splice(i, 1);
                break;
            }
        }
        crop.calibrationValue = 0;
        cropRemoved(crop);
    }

    function cropAdded(crop) {
        for (var i = 0; i < vm.unselectedCrops.length; i++) {
            if (crop.nameId == vm.unselectedCrops[i].nameId) {
                vm.unselectedCrops.splice(i, 1);
                break;
            }
        }
    }

    function cropRemoved(crop) {
        vm.unselectedCrops.push(crop);
        vm.unselectedCrops = $filter('orderBy')(vm.unselectedCrops, 'value.placement');
    }

    function searchCrops(searchText) {
        var searchedCrops = [];
        for (var i = 0; i < vm.unselectedCrops.length; i++) {
            if (vm.unselectedCrops[i].value.name.toLowerCase().startsWith(searchText.toLowerCase()) === true) {
                searchedCrops.push(vm.unselectedCrops[i]);
            }
        }
        return searchedCrops;
    }

    function formatTheDate(ts) {
        let date = new Date(ts);
        return ((date.getHours() + '').length < 2 ? ('0' + date.getHours()) : date.getHours())
            + ':'
            + ((date.getMinutes() + '').length < 2 ? ('0' + date.getMinutes()) : date.getMinutes())
            + ' '
            + date.toLocaleDateString();
    }

    vm.saveBilling = function(theForm) {
        if(user.authority === "CUSTOMER_USER") {
            let customerInfo = {
                email: user.sub,
                info: {
                    billingInfo: vm.customer.additionalInfo.billingInfo
                }
            }
            customerService.noAuthSaveCustomerBilling(customerInfo).then(() => {
                theForm.$invalid = true;
            });
        } else {
            customerService.saveCustomer(vm.customer).then(() => {
                theForm.$invalid = true;
            });
        }
    };

}
